export default __webpack_public_path__ + "static/media/DejaVuSans.67ed0b9a.ttf";